import {useEffect} from 'react'
import {EmailModalHeader} from './EmailModalHeader'
import {EmailModalFormWrapper} from './EmailModalFormWrapper'

const EmailModal = ({
  cycleId,
  onClose,
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-700px`}>
          <div className='modal-content'>
            <EmailModalHeader onClose={onClose} />
            <div className={`modal-body scroll-y mx-5 mx-xl-5`}>
              <EmailModalFormWrapper cycleId={cycleId} onClose={onClose} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {EmailModal}
